import React from 'react';
import { cn } from 'src/lib/utils';

const ColorPalette = ({ variant = 'brand', items = [], title, className }) => {
  if (variant === 'semantic') {
    const semanticItems = items.length
      ? items
      : [
          { name: 'Success', bg: 'var(--success-bg)', fg: 'var(--success)' },
          { name: 'Warning', bg: 'var(--warning-bg)', fg: 'var(--warning)' },
          { name: 'Danger', bg: 'var(--danger-bg)', fg: 'var(--danger)' },
          { name: 'Info', bg: 'var(--info-bg)', fg: 'var(--info)' },
        ];
    return (
      <div className={cn('mb-6', className)}>
        {title && (
          <div className='text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3'>{title}</div>
        )}
        <div className='grid grid-cols-4 gap-3'>
          {semanticItems.map(({ name, bg, fg }) => (
            <div key={name} className='rounded-xl overflow-hidden shadow-sm'>
              <div className='h-14 flex items-center justify-center' style={{ background: bg, color: fg }} />
              <div className='p-2.5 bg-card border-t border-border'>
                <div className='text-xs font-semibold text-foreground'>{name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={cn('mb-6', className)}>
      {title && (
        <div className='text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3'>{title}</div>
      )}
      <div className='flex rounded-xl overflow-hidden shadow-md'>
        {items.map(({ name, hex }) => (
          <div key={name} className='flex-1'>
            <div className='h-[88px]' style={{ background: hex }} />
            <div className='p-2.5 bg-card border-t border-border'>
              <div className='text-[11px] font-semibold text-foreground'>{name}</div>
              <div className='font-mono text-[10px] text-muted-foreground'>{hex}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { ColorPalette };
